

module.exports = __webpack_require__.stylable.create(
    "RunningIcon1384634745",
    {"classes":{"root":"RunningIcon1384634745__root","rootCircle":"RunningIcon1384634745__rootCircle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "RunningIcon1384634745",
    null
);
